export default __webpack_public_path__ + "static/media/vivez-clichy-marker.d866afb2.jpeg";